import React from 'react';
import { CheckboxElement as CheckboxType } from '../../types/element.types';

interface CheckboxElementProps {
  element: CheckboxType;
}

/**
 * Checkbox Element Renderer
 */
const CheckboxElement: React.FC<CheckboxElementProps> = ({ element }) => {
  const { label, checked, required, name } = element.settings || {};

  return (
    <label
      className="checkbox-element flex items-center gap-2 cursor-pointer"
      style={element.styles as React.CSSProperties}
    >
      <input
        type="checkbox"
        defaultChecked={checked}
        required={required}
        name={name}
        className="w-4 h-4"
      />
      <span>
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </span>
    </label>
  );
};

export default CheckboxElement;

